import { RiskLikelihood } from 'models/RiskCategories';

import SvgRiskBars_HighDark from 'assets/RiskBars/risk-bars-high-dark.svg';
import SvgRiskBars_HighLight from 'assets/RiskBars/risk-bars-high-light.svg';
import SvgRiskBars_LowDark from 'assets/RiskBars/risk-bars-low-dark.svg';
import SvgRiskBars_LowLight from 'assets/RiskBars/risk-bars-low-light.svg';
import SvgRiskBars_ModerateDark from 'assets/RiskBars/risk-bars-moderate-dark.svg';
import SvgRiskBars_ModerateLight from 'assets/RiskBars/risk-bars-moderate-light.svg';
import SvgRiskBars_NegligibleDark from 'assets/RiskBars/risk-bars-negligible-dark.svg';
import SvgRiskBars_NegligibleLight from 'assets/RiskBars/risk-bars-negligible-light.svg';
import SvgRiskBars_VeryHigh from 'assets/RiskBars/risk-bars-very-high.svg';

// TODO: cd961e06: dup, extract to utils
type IconMapping = {
  img: string;
  imgDark: string;
  title: string;
  numbers: string;
};
export const ProbabilityIconMappings: Partial<{ [key in RiskLikelihood]: IconMapping }> = {
  'Not calculated': {
    img: SvgRiskBars_NegligibleLight,
    imgDark: SvgRiskBars_NegligibleDark,
    title: null,
    numbers: 'Not calculated',
  },
  'Calculating, revisit later!': {
    img: SvgRiskBars_NegligibleLight,
    imgDark: SvgRiskBars_NegligibleDark,
    title: null,
    numbers: 'Calculating, revisit later!',
  },
  Unlikely: {
    img: SvgRiskBars_NegligibleLight,
    imgDark: SvgRiskBars_NegligibleDark,
    title: 'Unlikely',
    numbers: '<1%',
  },
  Low: {
    img: SvgRiskBars_LowLight,
    imgDark: SvgRiskBars_LowDark,
    title: 'Low Likelihood',
    numbers: '1% to 10%',
  },
  Moderate: {
    img: SvgRiskBars_ModerateLight,
    imgDark: SvgRiskBars_ModerateDark,
    title: 'Moderate Likelihood',
    numbers: '11% to 50%',
  },
  High: {
    img: SvgRiskBars_HighLight,
    imgDark: SvgRiskBars_HighDark,
    title: 'High Likelihood',
    numbers: '51% to 90%',
  },
  'Very high': {
    img: SvgRiskBars_VeryHigh,
    imgDark: SvgRiskBars_VeryHigh,
    title: 'Very High Likelihood',
    numbers: '91% to 100%',
  },
};
